import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Banner, BannerCreate, BannerFilter } from '../data/banner';

export function createBannerService(client: AxiosInstance) {
  return createCrudService<Banner, BannerCreate, BannerFilter>(
    client,
    '/Banner',
    'bannerId',
  );
}

export type BannerService = CrudService<Banner, BannerCreate, BannerFilter>;
